import React, { useState, useRef,useLayoutEffect } from 'react';
import {styled,useTheme} from '@mui/material/styles'
import { Box,  Snackbar, Typography} from '@mui/material';
import {useSelector, useDispatch} from 'react-redux'; 
import useMediaQuery from '@mui/material/useMediaQuery';
import { Camera} from "react-use-camera";
import axios from 'axios';

const BackCamera = ({handleEnd}) => {

const theme = useTheme()
const [currentColor, setCurrentColor] = useState('#1f0000'); 
const [isAnimating, setIsAnimating] = useState(false);
const [imageData, setImageData] = useState(null);
const webcamRef = useRef(null);
const size_sm = useMediaQuery(theme.breakpoints.up('xs'));
const [message,setMessage] = useState("")
const user = useSelector(state => state?.auth.user);
const data = useSelector(state => state?.test.test);
const [warn,setWarn] = useState(0)
const [isFirstTime,setIsFirstTime] = useState(true)
const [picture,setPicture] = useState({path:"",type:""})
const [insight,setInsight] = useState({})
const colors = ['#FFe000', '#FFF100', '#00F0F0'];
const [open,setOpen] = useState(false)
let warning = 0

const animateColor = () => {
    let colorIndex = 0; 

    const intervalId = setInterval(() => {
      setCurrentColor(colors[colorIndex]);
      colorIndex = (colorIndex + 1) % colors.length; 
      setIsAnimating(true);
    }, 1000); 

    return () => clearInterval(intervalId);
  };


async function handleSend(imageSrc) {

    const formData = new FormData()

    if(!isFirstTime){
        formData.append("file",imageSrc)
        formData.append("first_name",user?.first_name)
        formData.append("is_first_time",isFirstTime) 
        formData.append("url",picture.path)
        formData.append("type", picture.type) 
    }else{
        formData.append("file",imageSrc)
        formData.append("first_name",user?.first_name)
        formData.append("is_first_time",isFirstTime)        
    }

    try {
        const response = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/auth/file/image-check/`, formData,{
               headers:{
                  "Content-Type":"multipart/form-data",
                  "Authorization":`Bear ${user?.accessToken}`
                }
           }).catch(err=>console.log(err));

        if (response?.status === 200 && response?.data?.success) {

            setInsight(response?.data?.response);

            if (response?.data?.response?.isWarning) {
                if (warning < 3) {
                    setWarn((prev)=>prev+1)
                    warning = warning+1
                    setMessage(response?.data?.response?.message); 
                    setOpen(true);
                } else {
                    handleEnd()
                }
            }

            if (isFirstTime) {
                setPicture({ path: response?.data?.path, type: response?.data?.type });
            }

            setIsFirstTime(false);
        } 
    } catch (error) {
        console.error('Error sending data:', error);
    }
}


useLayoutEffect(() => {
    const intervalId = setInterval(async () => {
        if (webcamRef.current) {
            const imageSrc = await webcamRef?.current?.capture(); 
            setImageData(imageSrc.blob)
            handleSend(imageSrc.blob)
            webcamRef?.current?.clear();
        }
    }, 60000); 

    return () => clearInterval(intervalId); 
}, []);

useLayoutEffect(() => {
    animateColor();
    return () => clearInterval();
  }, [insight]);


return (
    <Box pt={3} sx={{ width: { xs: 100, md: 200, lg: 200 } }}>
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            message={message}
            onClose={() => setOpen(false)}
            open={open}
            autoHideDuration={5000}
        />
        <Box height={150} width={120} sx={{ padding: 1, background: "#000000", borderRadius: 2, margin: 1 }}>
            <Camera
                ref={webcamRef}
                style={{width:100,height:140}}
                errorLayout={<div>Oops! error to load your camera. please verify your settings for permission or check you have a camera you your browser support it</div>}
                onReady={() => console.log("Camera is now visible to the user")}
                onError={(e) => console.error("Camera couldn't load :(")}
            />
        </Box>
        {insight && (
            <Box sx={{ justifyContent: "flex-start", alignItems: "center", width: { xs: 80, md: 160 } }}>
                <Typography className={isAnimating ? 'animated-text' : ''} sx={{ fontSize: 10, textAlign: "left", padding: 1, color: currentColor }}>
                    {insight?.message}
                </Typography>
                <Typography sx={{ fontSize: 11, textAlign: "left", padding: 1, background: "red" }}>
                    Warning: {warn}/3
                </Typography>
            </Box>
        )}
    </Box>

);
};

export default BackCamera;
